import React, {Component} from 'react'
import PropTypes from 'prop-types'
import printImage from '../../helpers/printImage'
import drawQRBox from "../../helpers/drawQRBox"


class NextBoxFBAPrintQR extends Component {
    _handleClickPrintQR = (e) => {
        e.preventDefault()

        this._requestPrintQR()
    }

    _requestPrintQR = async () => {
        const {box, indexBoxClosed, statistics} = this.props
        const imageQr = await drawQRBox(box, indexBoxClosed, statistics)

        console.log(imageQr)
        printImage(imageQr)
    }

    render() {
        return (
            <div className="NextBoxPrintQR">
                <button onClick={this._handleClickPrintQR} className="btn btn-primary">Print QR</button>
            </div>
        )
    }
}

NextBoxFBAPrintQR.propTypes = {
    box: PropTypes.object.isRequired,
    indexBoxClosed: PropTypes.number,
    statistics: PropTypes.array
}

export default NextBoxFBAPrintQR
